export default __webpack_public_path__ + "static/media/Rubik-Black.58cb5698.woff";